// src/services/codigoSesionPosService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'codigos-sesion-pos/';

// Interfaz para CodigoSesionPosConfig
export interface CodigoSesionPosConfig {
    id: number;
    nombre: string;
    prefijo: string;
    activo: boolean;
    fecha_creacion: string;
}

// Obtener todos los prefijos
export const fetchCodigoSesionPosConfigs = async (): Promise<CodigoSesionPosConfig[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

// Crear un nuevo prefijo de sesión POS
export const createCodigoSesionPosConfig = async (data: {
    nombre: string;
    prefijo: string;
    activo: boolean;
}): Promise<CodigoSesionPosConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// Actualizar un prefijo existente
export const updateCodigoSesionPosConfig = async (
    id: number,
    data: {
        nombre: string;
        prefijo: string;
        activo: boolean;
    }
): Promise<CodigoSesionPosConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Eliminar un prefijo
export const deleteCodigoSesionPosConfig = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};